(function () {
  const CUSTOM_SORT_VALUES = ['effective-price-asc', 'effective-price-desc'];
  const GRID_SELECTOR = '#template--collection';
  const PRODUCT_SELECTOR = '[data-product-tile]';
  const SORT_SELECT_SELECTOR = '#SortBy';

  function getSortSelect() {
    return document.querySelector(SORT_SELECT_SELECTOR);
  }

  function getCurrentSortValue() {
    const select = getSortSelect();
    if (select && select.value) return select.value;

    const params = new URLSearchParams(window.location.search);
    return params.get('sort_by') || '';
  }

  function isCustomSort(sortValue) {
    return CUSTOM_SORT_VALUES.includes(sortValue);
  }

  function getGrid() {
    return document.querySelector(GRID_SELECTOR);
  }

  function getProductItems() {
    const grid = getGrid();
    if (!grid) return [];
    return Array.from(grid.querySelectorAll(PRODUCT_SELECTOR));
  }

  function getSortPrice(el) {
    return parseFloat(el.dataset.sortMinAdjustedPrice || '0');
  }

  function sortRenderedProducts(sortValue) {
    if (!isCustomSort(sortValue)) return;

    const grid = getGrid();
    if (!grid) return;

    const items = getProductItems();
    if (!items.length) return;

    const ascending = sortValue === 'effective-price-asc';

    items.sort((a, b) => {
      const aPrice = getSortPrice(a);
      const bPrice = getSortPrice(b);

      if (aPrice === bPrice) {
        const aId = parseInt(a.dataset.productId || '0', 10);
        const bId = parseInt(b.dataset.productId || '0', 10);
        return aId - bId;
      }

      return ascending ? aPrice - bPrice : bPrice - aPrice;
    });

    const frag = document.createDocumentFragment();
    items.forEach((item) => frag.appendChild(item));
    grid.appendChild(frag);
  }

  function updateUrlSortParam(sortValue) {
    const url = new URL(window.location.href);

    if (sortValue) {
      url.searchParams.set('sort_by', sortValue);
    } else {
      url.searchParams.delete('sort_by');
    }

    history.replaceState(
      { searchParams: url.searchParams.toString() },
      '',
      `${url.pathname}${url.search}`
    );
  }

  function syncSelectToUrl() {
    const select = getSortSelect();
    if (!select) return;

    const params = new URLSearchParams(window.location.search);
    const urlSort = params.get('sort_by');

    if (urlSort && select.value !== urlSort) {
      select.value = urlSort;
    }
  }

  function applyCustomSortIfNeeded() {
    const sortValue = getCurrentSortValue();
    if (!isCustomSort(sortValue)) return;
    sortRenderedProducts(sortValue);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncSelectToUrl();
    applyCustomSortIfNeeded();
  });

  document.addEventListener('paginate', function () {
    applyCustomSortIfNeeded();
  });

  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!target.matches(SORT_SELECT_SELECTOR)) return;

    const sortValue = target.value;

    // Update URL immediately so custom logic and browser state stay in sync
    updateUrlSortParam(sortValue);

    // Let filtering.js do its AJAX refresh, then re-apply custom DOM sorting if needed
    window.setTimeout(function () {
      applyCustomSortIfNeeded();
    }, 650);
  });

  window.addEventListener('popstate', function () {
    syncSelectToUrl();

    window.setTimeout(function () {
      applyCustomSortIfNeeded();
    }, 50);
  });
})();